import Exporter from '../../exporter/Exporter'
import json2jsonl from '../../utils/jsonl'

/** Read-only export preparation shared by the visible export popup and tests. */
export function prepareFirmwareExport(settings, layer) {
    const exporter = new Exporter()
    const exportData = exporter.doExport(settings, layer)
    return {
        exportData,
        jsonl: json2jsonl(exportData),
        validationErrors: exporter.validationErrors ?? [],
        validationErrorCategories: exporter.validationErrorCategories ?? [],
        warnings: exporter.warnings ?? [],
    }
}
